
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/appraisal",
      function () {
        return require("private-next-pages/services/appraisal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/appraisal"])
      });
    }
  